import { computed } from "vue"
import { mapState } from "vuex"

export default function useCommonCount(key) {
  const filters = mapState("filter", {
    [key]: ({ filters }) => filters[key],
  })

  const filter = computed(filters[key])
  const filterLength = computed(() => filter.value.length)

  return computed(() => ({
    badgeContent: filterLength.value,
    badgeCondition: filterLength.value > 0,
  }))
}
